import type { ITelemetryItem } from '@microsoft/applicationinsights-web';

import { scrubUrl } from './telemetryRedaction';

// Deep enough for baseData.exceptions[i].parsedStack[j].fileName; also ends any cycle.
const MAX_DEPTH = 6;

const scrubStrings = (node: Record<string, unknown>, depth: number): void => {
  // Object.keys, not array iteration: the SDK's tags array also carries named keys such as ai.operation.name.
  for (const key of Object.keys(node)) {
    const value = node[key];
    if (typeof value === 'string') {
      const scrubbed = scrubUrl(value);
      if (scrubbed !== value) {
        node[key] = scrubbed;
      }
    } else if (value !== null && typeof value === 'object' && depth < MAX_DEPTH) {
      scrubStrings(value as Record<string, unknown>, depth + 1);
    }
  }
};

/** Telemetry initializer that scrubs every string under ext.trace, tags, baseData and data (six levels deep); returns false (drop the item) when scrubbing fails. */
export function scrubTelemetryItem(item: ITelemetryItem): boolean {
  try {
    for (const root of [item.ext?.trace, item.tags, item.baseData, item.data]) {
      if (root !== null && typeof root === 'object') {
        scrubStrings(root as Record<string, unknown>, 1);
      }
    }
    return true;
  } catch {
    // The SDK still sends an item whose initializer threw, unscrubbed.
    return false;
  }
}
